module.exports = __webpack_public_path__ + "img/brandImg1.f0b18bb8.jpg";